import React from 'react';
import { Button } from 'react-bootstrap';
import { useFetchedCanRevertCanceledSubscription } from '../hooks/useFetchedCanRevertCanceledSubscription';
import { useRevertCancellationMutation } from '../hooks/useRevertCancellationMutation';

export const ResumeSubscriptionButton = () => {
  const { query } = useFetchedCanRevertCanceledSubscription();
  const revertMutation = useRevertCancellationMutation();

  if (query.isLoading) return null;
  if (!query.data?.canRevert) return null;

  return (
    <Button
      variant="primary"
      className="button-apply"
      onClick={() => revertMutation.mutate()}
      disabled={revertMutation.isLoading}
      data-test="billing__resume-subscription-btn"
      aria-label="Resume Plan"
      tabIndex={0}
    >
      {revertMutation.isLoading ? 'Resuming...' : 'Resume Plan'}
    </Button>
  );
};
